<template>
  <div>
    <ResultFilesViewProgress
      :selectedStatuses="statuses"
    ></ResultFilesViewProgress>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
const ResultFilesViewProgress = defineAsyncComponent(() =>
  import("@/views/results/AllResultsViewProgress")
);
export default {
  components: {
    ResultFilesViewProgress,
  },
  data() {
    return {
      statuses: "COMPLETED",
    };
  },
};
</script>
